import BoldSmallText from '@/components/BoldSmallText';
import InputColorPicker from '@/pages/WidgetAppearance/component/common/InputColorPicker';
import {
  handleSaveWidgetColors,
  handleSetWidgetColorError,
  widgetAppearanceDisableSelector,
  widgetColorErrorsSelector,
  widgetColorSelector,
} from '@/redux/slice/widget.slice';
import { BlockStack, FormLayout } from '@shopify/polaris';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

export const Message = () => {
  const { t } = useTranslation('widget_settings');
  const widgetColor = useSelector(widgetColorSelector);
  const widgetColorError = useSelector(widgetColorErrorsSelector);
  const dispatch = useDispatch();
  const widgetAppearanceDisable = useSelector(widgetAppearanceDisableSelector);
  return (
    <BlockStack gap={'200'}>
      <BoldSmallText>{t('widgetDesign.colour.message.title')}</BoldSmallText>
      <FormLayout.Group>
        <InputColorPicker
          label={t('widgetDesign.colour.message.eligibleMessage')}
          colorKey={'headingTitle'}
          colorValue={widgetColor.body.eligibleMessageColor}
          onChange={(color) =>
            dispatch(
              handleSaveWidgetColors({
                body: {
                  ...widgetColor.body,
                  eligibleMessageColor: color,
                },
              }),
            )
          }
          error={widgetColorError.body.eligibleMessageColor}
          setError={(error) =>
            dispatch(
              handleSetWidgetColorError({
                body: {
                  ...widgetColorError.body,
                  eligibleMessageColor: {
                    ...error,
                  },
                },
              }),
            )
          }
          disabled={widgetAppearanceDisable.isDisableCustomStyle}
        />
        <InputColorPicker
          label={t('widgetDesign.colour.message.errorMessage')}
          colorKey={'headingTitle'}
          colorValue={widgetColor.body.errorColor}
          onChange={(color) =>
            dispatch(
              handleSaveWidgetColors({
                body: {
                  ...widgetColor.body,
                  errorColor: color,
                },
              }),
            )
          }
          error={widgetColorError.body.errorColor}
          setError={(error) =>
            dispatch(
              handleSetWidgetColorError({
                body: {
                  ...widgetColorError.body,
                  errorColor: {
                    ...error,
                  },
                },
              }),
            )
          }
          disabled={widgetAppearanceDisable.isDisableCustomStyle}
        />
        <InputColorPicker
          label={t('widgetDesign.colour.message.requiredMessage')}
          colorKey={'headingTitle'}
          colorValue={widgetColor.body.requiredMessageColor}
          onChange={(color) =>
            dispatch(
              handleSaveWidgetColors({
                body: {
                  ...widgetColor.body,
                  requiredMessageColor: color,
                },
              }),
            )
          }
          error={widgetColorError.body.requiredMessageColor}
          setError={(error) =>
            dispatch(
              handleSetWidgetColorError({
                body: {
                  ...widgetColorError.body,
                  requiredMessageColor: {
                    ...error,
                  },
                },
              }),
            )
          }
          disabled={widgetAppearanceDisable.isDisableCustomStyle}
        />
        <InputColorPicker
          label={t('widgetDesign.colour.message.additionalMessage')}
          colorKey={'headingTitle'}
          colorValue={widgetColor.body.additionalNotesColor}
          onChange={(color) =>
            dispatch(
              handleSaveWidgetColors({
                body: {
                  ...widgetColor.body,
                  additionalNotesColor: color,
                },
              }),
            )
          }
          error={widgetColorError.body.additionalNotesColor}
          setError={(error) =>
            dispatch(
              handleSetWidgetColorError({
                body: {
                  ...widgetColorError.body,
                  additionalNotesColor: {
                    ...error,
                  },
                },
              }),
            )
          }
          disabled={widgetAppearanceDisable.isDisableCustomStyle}
        />
      </FormLayout.Group>
    </BlockStack>
  );
};
